import { Spinner } from "@/modules/shadcn/ui/spinner";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router";
import { useVerifyEmailMutation } from "../../services";

export const VerifyEmailPage = () => {
  const { t } = useTranslation(["auth", "common"]);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [verifyEmail] = useVerifyEmailMutation();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    verifyEmail({ token })
      .unwrap()
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (status !== "success") return;
    const id = setTimeout(() => navigate("/login", { replace: true }), 5000);
    return () => clearTimeout(id);
  }, [status, navigate]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="relative flex h-full w-full flex-col items-center justify-center px-8 py-16">
      <div className="flex w-full max-w-100 flex-col">
        {status === "loading" && (
          <div className="flex flex-col items-center gap-4">
            <Spinner className="size-8" />
            <p className="text-muted-foreground">{t("verifyEmail.verifying")}</p>
          </div>
        )}

        {status === "success" && (
          <>
            <div className="mb-10 flex flex-col items-center gap-2 text-center">
              <h2 className="text-4xl font-semibold tracking-tight text-gray-900">
                {t("verifyEmail.doneTitle")}
              </h2>
              <p className="text-muted-foreground">
                {t("verifyEmail.doneBody")}
              </p>
            </div>
            <div className="mt-8 flex flex-col items-center gap-4">
              <Link
                to="/login"
                className="text-sm font-semibold text-primary hover:underline"
              >
                {t("links.goToLogin")}
              </Link>
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <div className="mb-10 flex flex-col items-center gap-2 text-center">
              <h2 className="text-4xl font-semibold tracking-tight text-gray-900">
                {t("verifyEmail.expiredTitle")}
              </h2>
              <p className="text-muted-foreground">
                {t("verifyEmail.expiredBody")}
              </p>
            </div>
            <div className="mt-8 flex flex-col items-center gap-4">
              <Link
                to="/login"
                className="text-sm font-semibold text-primary hover:underline"
              >
                {t("links.backToLogin")}
              </Link>
            </div>
          </>
        )}
      </div>
      <div className="absolute bottom-8 left-0 right-0 mx-16 border-t border-gray-100 pt-6 text-center text-xs text-gray-400">
        {t("common:footer.line")}
      </div>
    </div>
  );
};
